/* import __COLOCATED_TEMPLATE__ from './upgrade-install-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();